module.exports = __webpack_public_path__ + "assets/img/logo-light.3bb631c2.png";